import React, { useState, useEffect } from 'react';

// Mui

import Typography from '@mui/material/Typography';
// Service
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';

import RacingService from 'services/RacingService';
import { Padding } from '@mui/icons-material';

const AccountSettingsContainer = styled(Grid)(({ theme }) => ({
    minHeight: '550px',
    '.MuiTypography-h3': {
        margin: '20px 0px 20px 0px',
        //color: '#fff',
        fontSize: '22px'
    },
    '.mainContainer': {
        border: '1px solid rgba(255,255,255,0.5)',
        borderRadius: '6px',
        display: 'flex',
        margin: '0px',
        width: 'calc(100%)',
        padding: '10px',
        table: {
            p: {
                Padding: '0px',
                margin: '0px',
                marginRight: '8px',
                fontWeight: '700',
                color: '#dd631a',
                textTransform: 'uppercase',
                fontSize: '11px'
            },
            span: { display: 'flex', Padding: '8px', paddingBottom: '5px', fontSize: '11px' },
            td: { borderBottom: '1px solid rgba(255,255,255,0.5)' },
            [theme.breakpoints.down('sm')]: {
                thead: { display: 'block' },
                'thead tr': {
                    position: 'absolute',
                    top: '-9999px',
                    left: '-9999px'
                },
                td: {
                    border: 'none',
                    // borderBottom: '1px solid #eee',
                    borderBottom: '1px solid rgba(255,255,255,0.5)',
                    position: 'relative',
                    // paddingLeft: '50% !important',
                    whiteSpace: 'normal',
                    textAlign: 'left',
                    display: 'block'
                    // height: '44px',
                },

                'td:before': {
                    content: 'attr(data-title)'
                },
                'tbody tr': {
                    display: 'block',
                    borderBottom: '1px solid rgba(255,255,255,0.5)'
                },

                'td::before': {
                    position: 'absolute',
                    top: '9px',
                    left: '6px',
                    width: '45%',
                    paddingRight: '10px',
                    whiteSpace: 'nowrap',
                    textAlign: 'left'
                },
                span: { display: 'flex', flexDirection: 'column', fontSize: '12px', fontWeight: '900' },
                p: {
                    Padding: '0px',
                    fontSize: '12px',
                    margin: '0px',
                    marginRight: '8px',
                    fontWeight: '700',
                    color: '#dd631a',
                    textTransform: 'uppercase'
                }
            },
            '.paymentamount': {
                [theme.breakpoints.down('sm')]: {
                    flexDirection: 'row'
                }
            }
        },
        '.leftContainer': {
            padding: '24px',
            '.MuiTypography-h4': {
                fontSize: '20px',
                color: '#fff',
                marginBottom: '8px'
            }
        },
        '.rightContainer': {
            borderLeft: '1px solid rgba(255,255,255,0.5)',
            ul: {
                padding: '0px',
                margin: '0px',
                listStyle: 'none',
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                li: {
                    display: 'flex',
                    alignItems: 'center',
                    height: '50px',
                    justifyContent: 'space-between',
                    width: '100%',
                    padding: '10px 20px',
                    borderBottom: '1px solid rgba(255,255,255,0.5)'
                }
            }
        },
        '.MuiTableCell-root ': { padding: '0px' },
        '.MuiTableCell-head': { backgroundColor: theme.palette.secondary.main },
        '.MuiTableHead-root': {
            '.MuiTableCell-head': {
                color: '#fff'
            }
        }
    }
}));

// Define the type for a transaction
interface Transaction {
    refundAmount: any;
    roundId: string;
    gameName: string;
    venueName: string;
    gameId: any;
    payoutAmount: any;
    operatorRunners: any;
    betOn: any;
    id: number;
    betId: string;
    transactionId: string;
    transactionDate: string;
    postBalance: number;
    preBalance: number;
    amount: number | null;
    status: string;
    gameType: string;
    gameResult: string;
}
const BettingHistory = () => {
    const theme = useTheme();
    // const [pageSize, setPageSize] = useState<number>(10);
    // const [page, setPage] = useState<number>(0);
    const [rows, setRows] = useState<Transaction[]>([]);
    // const [rowCount, setRowCount] = useState<number>(0);
    useEffect(() => {
        const getTransactions = async () => {
            const params = {};
            const response = await RacingService.getUserbets(params);
            const jsonData = response.data.data.data.reverse();
            // setRowCount(jsonData.length);
            setRows(jsonData);
        };
        getTransactions();
    }, []);

    const positionDisplayMap = {
        1: { position: 1, text: 'YELLOW', code: 'YW' },
        2: { position: 2, text: 'DARK BLUE', code: 'DB' },
        3: { position: 3, text: 'ORANGE', code: 'OR' },
        4: { position: 4, text: 'SKY BLUE', code: 'SB' },
        5: { position: 5, text: 'BROWN', code: 'BW' },
        6: { position: 6, text: 'LIGHT GREEN', code: 'LG' },
        7: { position: 7, text: 'RED', code: 'RD' },
        8: { position: 8, text: 'VIOLET', code: 'VT' },
        9: { position: 9, text: 'DARK GREEN', code: 'DG' },
        10: { position: 10, text: 'PINK', code: 'PK' },
        11: { position: 11, text: 'SILVER', code: 'SV' },
        12: { position: 12, text: 'IVORY', code: 'IV' }
    };

    function transformOperatorRunners(input: any) {
        if (!input) return '';

        // Determine the separator used in the input
        const separator = input.includes('/') ? '/' : input.includes('-') ? '-' : null;

        if (separator) {
            // Split the input by the separator to get groups
            return input
                .split(separator)
                .map((group: any) =>
                    // Split each group by ',' to get individual numbers
                    group
                        .split(',')
                        .map((num: any) => {
                            const code = positionDisplayMap[parseInt(num)]?.code;
                            return code || num; // Fallback to original number if code not found
                        })
                        .join(',')
                )
                .join(separator);
        } else {
            // Input is a simple comma-separated list
            return input
                .split(',')
                .map((num: any) => {
                    const code = positionDisplayMap[parseInt(num)]?.code;
                    return code || num; // Fallback to original number if code not found
                })
                .join(',');
        }
    }

    return (
        <AccountSettingsContainer>
            <Grid container>
                <Grid item xs={12}>
                    <Typography
                        variant="h3"
                        sx={{
                            color: theme.palette.secondary.main,
                            [theme.breakpoints.down('sm')]: {
                                fontSize: '18px !important'
                            }
                        }}
                    >
                        Betting History
                    </Typography>
                </Grid>
            </Grid>
            <Grid container className="mainContainer">
                <TableContainer sx={{ background: '#050505' }} component={Paper}>
                    <Table sx={{}} aria-label="simple table">
                        <TableBody>
                            {rows &&
                                rows.map((bet, key) => {
                                    return (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell>
                                                <Stack
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        [theme.breakpoints.down('sm')]: {
                                                            flexDirection: 'column'
                                                        }
                                                    }}
                                                >
                                                    <Stack
                                                        sx={{
                                                            width: '100%',
                                                            [theme.breakpoints.down('sm')]: {
                                                                width: '100%'
                                                            }
                                                        }}
                                                    >
                                                        <span style={{ paddingTop: '6px' }}>
                                                            <p>Bet Id :</p>
                                                            {bet.betId}
                                                        </span>
                                                    </Stack>

                                                    <Stack
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection: 'row',
                                                            [theme.breakpoints.down('sm')]: {
                                                                flexDirection: 'row'
                                                            }
                                                        }}
                                                    >
                                                        <Stack
                                                            sx={{
                                                                width: '50%',
                                                                [theme.breakpoints.down('sm')]: {
                                                                    width: '60%'
                                                                }
                                                            }}
                                                        >
                                                            <span>
                                                                <p>Tran. Id :</p>
                                                                {bet.transactionId}
                                                            </span>

                                                            <span>
                                                                <p>Type :</p>
                                                                {bet.gameType}
                                                            </span>
                                                            <span>
                                                                <p>Event : </p>
                                                                {!isNaN(Number(bet.gameId))
                                                                    ? `${bet.venueName != null ? bet.venueName + ' / ' : ''}Event ${bet.gameId}`
                                                                    : `${bet.venueName != null ? bet.venueName + ' / ' : ''} ${bet.gameId}`}
                                                            </span>
                                                            <span>
                                                                <p>Bet On:</p>
                                                                {bet.gameType === 'Classic Karambola'
                                                                    ? transformOperatorRunners(bet.operatorRunners)
                                                                    : bet.gameType === 'Classic HR'
                                                                      ? bet.operatorRunners
                                                                      : bet.betOn}
                                                            </span>
                                                            <span>
                                                                <p>Round Id:</p>
                                                                {bet.roundId ?? '-'}
                                                            </span>
                                                        </Stack>

                                                        <Stack
                                                            sx={{
                                                                width: '50%',
                                                                [theme.breakpoints.down('sm')]: {
                                                                    width: '40%'
                                                                }
                                                            }}
                                                        >
                                                            <span>
                                                                <p>Tran. Date :</p>
                                                                {bet.transactionDate}
                                                            </span>
                                                            <span
                                                                className="paymentamount"
                                                                style={{
                                                                    [theme.breakpoints.down('sm')]: {
                                                                        flexDirection: 'row'
                                                                    }
                                                                }}
                                                            >
                                                                <p>Bet : </p>
                                                                {bet.amount && bet.amount > 0 ? `₱ ${bet.amount.toFixed(2)}` : '-'}
                                                            </span>

                                                            <span
                                                                className="paymentamount"
                                                                style={{
                                                                    [theme.breakpoints.down('sm')]: {
                                                                        flexDirection: 'row'
                                                                    }
                                                                }}
                                                            >
                                                                <p>Pay Amt : </p>
                                                                {bet.payoutAmount && bet.payoutAmount > 0
                                                                    ? `₱ ${bet.payoutAmount.toFixed(2)}`
                                                                    : '-'}
                                                            </span>
                                                            <span
                                                                className=""
                                                                style={{
                                                                    [theme.breakpoints.down('sm')]: {
                                                                        flexDirection: 'row'
                                                                    }
                                                                }}
                                                            >
                                                                <p>CANCELLED Amt : </p>
                                                                {bet.refundAmount && bet.refundAmount > 0
                                                                    ? `₱ ${bet.refundAmount.toFixed(2)}`
                                                                    : '-'}
                                                            </span>
                                                            <span
                                                                className=""
                                                                style={{
                                                                    [theme.breakpoints.down('sm')]: {
                                                                        flexDirection: 'column'
                                                                    }
                                                                }}
                                                            >
                                                                <p>Status :</p>
                                                                {bet.status ?? '-'}
                                                            </span>
                                                            <span>
                                                                <p>Result :</p>
                                                                {bet.gameResult}
                                                            </span>
                                                        </Stack>
                                                    </Stack>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </AccountSettingsContainer>
    );
};

export default BettingHistory;
